import type { AriaAttributes, FunctionComponent, ReactNode } from "react";
import { useState } from "react";
import { usePopper } from "react-popper";
import * as headless from "@headlessui/react";
import { cx } from "class-variance-authority";
import { Menu } from "../Menu";
import { transitionVariants } from "../Transitions/transitionVariants";

export interface TableSubMenuProps extends AriaAttributes {
  children: ReactNode;
}

/**
 *
 */
export const TableSubMenu: FunctionComponent<TableSubMenuProps> = ({
  children,
  ...rest
}) => {
  const [referenceElement, setReferenceElement] = useState<any>();
  const [popperElement, setPopperElement] = useState<any>();
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    strategy: "fixed",
    placement: "bottom-end",
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 5],
        },
      },
    ],
  });
  return (
    <headless.Menu>
      <headless.Menu.Button
        {...rest}
        className="table-submenu"
        ref={setReferenceElement}
      >
        <div className="table-submenu__icon" />
        <div className="table-submenu__gap" />
        <div className="table-submenu__body">
          <div className="table-submenu__circle" />
          <div className="table-submenu__circle" />
          <div className="table-submenu__circle" />
        </div>
      </headless.Menu.Button>
      <headless.Menu.Items
        as={Menu.MenuItems}
        className={cx()}
        ref={setPopperElement}
        style={styles.popper}
        {...attributes.popper}
      >
        <headless.Transition
          {...transitionVariants.menuItemsTransitionVariant}
          appear
        >
          <div>{children}</div>
        </headless.Transition>
      </headless.Menu.Items>
    </headless.Menu>
  );
};
